import { deleteDataAPI, getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Blogs and their categories.
 *
 * The council routes sit behind admin.verify; the website ones are open and
 * ask for active=1, which is what keeps a draft off the public site.
 */

const adminToken = () => localStorage.getItem("adminToken");

const fail = (error, fallback) => {
  if (error.response?.data?.message === "Validation errors") {
    const data = error.response.data.data || {};
    const first = Object.values(data)[0];
    errorAlert(Array.isArray(first) ? first[0] : fallback);
  } else {
    errorAlert(error.response?.data?.message || fallback);
  }
  return false;
};

/* ------------------------------ categories ------------------------------ */

export const getBlogCategories = (publicOnly) => async (dispatch) => {
  try {
    const url = publicOnly
      ? "blog/categories?active=1"
      : "admin/blog/category/list";
    const response = await dispatch(
      getDataAPI(url, publicOnly ? undefined : adminToken())
    );
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const saveBlogCategory = (data, id) => async (dispatch) => {
  try {
    const url = id
      ? `admin/blog/category/update/${id}`
      : "admin/blog/category/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The category could not be saved.");
  }
};

export const deleteBlogCategory = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/blog/category/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The category could not be deleted.");
  }
};

/* -------------------------------- posts --------------------------------- */

export const getBlogs = (params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    ["category", "frequency", "search", "page", "per_page", "active"].forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== "" && value !== "all") {
        q.append(key, value);
      }
    });
    const suffix = q.toString() ? `?${q.toString()}` : "";

    const url = params.active ? `blog/list${suffix}` : `admin/blog/list${suffix}`;
    const response = await dispatch(
      getDataAPI(url, params.active ? undefined : adminToken())
    );
    return response.data.data;
  } catch (error) {
    return false;
  }
};

export const getBlogDetails = (ref) => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI(`blog/details/${ref}`));
    return response.data.data;
  } catch (error) {
    return false;
  }
};

export const saveBlog = (data, id) => async (dispatch) => {
  try {
    const url = id ? `admin/blog/update/${id}` : "admin/blog/create";
    const response = await dispatch(postDataAPI(url, data, adminToken()));
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The blog could not be saved.");
  }
};

export const deleteBlog = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      deleteDataAPI(`admin/blog/delete/${id}`, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The blog could not be deleted.");
  }
};

/* Approve / reject a blog a centre submitted. */
export const approveBlog = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI(`admin/blog/approve/${id}`, {}, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The blog could not be approved.");
  }
};

export const rejectBlog = (id, reason) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI(`admin/blog/reject/${id}`, { reason }, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    return fail(error, "The blog could not be rejected.");
  }
};
